var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApprenticeship(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0004 19C10.7357 19 11.357 18.4897 11.5488 17.7952H8.45209C8.64411 18.4895 9.26588 19 10.0004 19Z",
    fill: "#0083FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74414 15.0842C6.74414 15.9975 7.46725 16.7413 8.35399 16.7413H11.6466C12.5339 16.7413 13.2564 15.997 13.2564 15.0842V14.4818H6.74414V15.0842Z",
    fill: "#0083FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1C6.6916 1 4 3.77061 4 7.17615C4 8.83165 4.6287 10.3857 5.77049 11.5521C6.2667 12.0585 6.59292 12.7222 6.70267 13.4273H13.2993C13.409 12.7223 13.7351 12.059 14.2316 11.5528C15.372 10.3846 16 8.83028 16 7.17615C16 3.77061 13.3084 1 10 1Z",
    fill: "#0083FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprenticeship);
export default __webpack_public_path__ + "static/media/apprenticeship.53209c1d.svg";
export { ForwardRef as ReactComponent };